<template>
    <div class="gallery-cls text-center">
    <v-dialog :value="value" @input="$emit('input')" hide-overlay class="banner-preview-modal dialog-masonry">
      <div class="pa-6 dialog-cls">
          <v-row>
            <v-col cols="12" sm="12" md="12">
                <div class="text-center">
                    <img class="image-preview" :src="previewUrl">
                </div>
            </v-col>
            <v-col cols="12" sm="12" md="12">
                <div class="text-center">
                  <code>{{ html }}</code>
                </div>
            </v-col>            
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
                <div class="text-right">
                    <slot></slot>
                    <v-btn @click.native="$emit('input')" outlined small>Close</v-btn> 
                </div>
            </v-col>
          </v-row>
      </div>
    </v-dialog>
    </div>
</template>

<script>
import { bannerHtml, bannerPreviewURL } from '@/utility/affiliate-utility'

export default {
  name: 'BannerPreviewModal',
  props: ['value', 'banner'],
  computed: {
    previewUrl () {
      if (this.banner) return bannerPreviewURL(this.banner)
      return ''
    },
    html () {
      if (this.banner) return bannerHtml(this.banner)
      return ''
    }
  }
}
</script>

<style scoped>
  .v-dialog__content.v-dialog__content--active {
    background: #0000007a;
  }
  .dialog-cls {
    background: #fff;
    width: 60%;
    margin: auto;         
  }
  .image-preview {
    max-width: 100%;
    max-height: 100%;
  }
  @media screen and (max-width: 691px) {
    .dialog-cls {
      width: 100%;
      margin: auto;         
    }
  }  
</style>